import { useWindowSize } from 'react-use';

/**
 * @description Determines the current browser window width.
 * isMobileView (for browser widths < 1280px).
 * isDesktopView (for browser widths >= 1280px).
 * isMdAndBelow (for browser widths < 480px - aligns with Constellation MD breakpoint).
 * isMdAndUp (for browser widths >= 480px).
 * @returns Object
 */
export default () => {
  const { width } = useWindowSize();

  return {
    isMobileView: width > 0 && width < 1280,
    isDesktopView: width >= 1280,
    isMdAndBelow: width > 0 && width < 480,
    isMdAndUp: width >= 480,
    isWindowWidthSet: width !== 0,
  };
};
